<script lang="ts" setup>
import ProductTable from "@/data-views/tables/product/ProductTable.vue";
definePage({
  meta: {
    action: "read",
    subject: "Product",
  },
});
</script>

<template>
  <VRow class="match-height">
    <VCol cols="12">
      <ProductTable />
    </VCol>
  </VRow>
</template>

<style lang="scss">
@use "@core/scss/template/libs/apex-chart.scss";
</style>
